import {
    useState, useRef, useCallback, useLayoutEffect,
} from 'react';

export default function useDroppable(onDrop) {
    const droppableRef = useRef();
    const [state, setState] = useState({
        isDragOver: false,
    });

    const handleDrop = useCallback((event) => {
        event.preventDefault();
        const data = event.dataTransfer.getData('application/json');

        setState({isDragOver: false});
        onDrop(JSON.parse(data));
    }, []);

    const handleDragOver = useCallback((event) => {
        event.preventDefault();

        setState({isDragOver: true});
    }, []);

    const handleDragLeave = useCallback((event) => {
        event.preventDefault();

        setState({isDragOver: false});
    }, []);

    useLayoutEffect(() => {
        if (!droppableRef.current) {
            return;
        }
        droppableRef.current.addEventListener('drop', handleDrop);
        droppableRef.current.addEventListener('dragover', handleDragOver);
        droppableRef.current.addEventListener('dragleave', handleDragLeave);

        () => {
            droppableRef.current.removeEventListener('drop', onDrop);
            droppableRef.current.removeEventListener('dragover', handleDragOver);
            droppableRef.current.removeEventListener('dragleave', handleDragLeave);
        };
    }, []);
    return [
        droppableRef,
        state.isDragOver,
    ];
}



// WEBPACK FOOTER //
// ./src/components/helpers/hooks/useDroppable.js